/* Costanti generiche. Valore:
null | {"machine_types": [...], "axes": [...], "stages": [...]}
*/
import { createContext } from "react";
const InfoContext = createContext({
    info: null,
    setInfo: (info) => {}
  });
export default InfoContext;